export { default } from './SkipLinks';
export { StyledSkipLinks } from './SkipLinks.styles';
export type { SkipLinksProps } from './SkipLinks';
